import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "font-size": "32px",
    "font-weight": "bolder"
  }
};
const _hoisted_2 = {
  style: {
    "flex": "1",
    "position": "relative"
  }
};
const _hoisted_3 = {
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0",
    "right": "0",
    "bottom": "0"
  }
};
import { computed, reactive, ref } from 'vue';
import TableSelect from './components/table-select/TableSelect.vue';
import TableProp from './components/table-prop/TableProp.vue';
import CodeGenerator from './components/code-generator/CodeGenerator.vue';
import { ArrowRight, ArrowLeft } from '@element-plus/icons-vue';
const TAB_TABLE_SELECT = 'table-select';
const TAB_TABLE_PROP = 'table-prop';
const TAB_CODE_GEN = 'code-gen';
export default /*@__PURE__*/_defineComponent({
  __name: 'Codegen',
  setup(__props) {
    const tablePropRef = ref();
    const tableSelectRef = ref();
    const tabRef = ref();
    const tab = reactive({
      active: TAB_TABLE_SELECT,
      tableSelect: {
        tableName: ''
      },
      tableProp: {
        business: {}
      }
    });
    const title = computed(() => {
      if (isTabActive(TAB_TABLE_SELECT)) {
        return '选择表';
      } else if (isTabActive(TAB_TABLE_PROP)) {
        return '调整属性';
      } else if (isTabActive(TAB_CODE_GEN)) {
        return '生成代码';
      }
      return '';
    });
    function handleTableSelect(table) {
      gotoTableProp(table);
    }
    function nextStep() {
      if (isTabActive(TAB_TABLE_SELECT)) {
        gotoTableProp(tableSelectRef.value?.getSelectedTableName());
      } else if (isTabActive(TAB_TABLE_PROP)) {
        gotoCodeGen();
      }
    }
    function gotoTableProp(tableName) {
      if (!tableName) {
        return;
      }
      tab.tableSelect.tableName = tableName;
      switchTab(TAB_TABLE_PROP);
    }
    function gotoCodeGen() {
      const business = tablePropRef.value?.getBusiness();
      if (!business) {
        return;
      }
      tab.tableProp.business = business;
      switchTab(TAB_CODE_GEN);
    }
    function previousStep() {
      if (isTabActive(TAB_TABLE_PROP)) {
        switchTab(TAB_TABLE_SELECT);
      } else if (isTabActive(TAB_CODE_GEN)) {
        switchTab(TAB_TABLE_PROP);
      }
    }
    function switchTab(tb) {
      tab.active = tb;
    }
    function isTabActive(tb) {
      return tab.active === tb;
    }
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button_group = _resolveComponent("el-button-group");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 20
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_1, _toDisplayString(title.value), 1)]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button_group, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "success",
                icon: _unref(ArrowLeft),
                onClick: previousStep
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("上一步")])),
                _: 1
              }, 8, ["icon"]), _createVNode(_component_el_button, {
                type: "success",
                onClick: nextStep
              }, {
                default: _withCtx(() => [_cache[2] || (_cache[2] = _createTextVNode("下一步")), _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [_createVNode(_unref(ArrowRight))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_divider)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tabs, {
          ref_key: "tabRef",
          ref: tabRef,
          modelValue: tab.active,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tab.active = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            style: {
              "height": "100%"
            },
            label: "选择表",
            name: "table-select"
          }, {
            default: _withCtx(() => [_createVNode(TableSelect, {
              ref_key: "tableSelectRef",
              ref: tableSelectRef,
              onSelect: handleTableSelect
            }, null, 512)]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            style: {
              "height": "100%"
            },
            label: "属性调整",
            name: "table-prop"
          }, {
            default: _withCtx(() => [_createVNode(TableProp, {
              ref_key: "tablePropRef",
              ref: tablePropRef,
              "table-name": tab.tableSelect.tableName
            }, null, 8, ["table-name"])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "代码生成",
            name: "code-gen"
          }, {
            default: _withCtx(() => [_createVNode(CodeGenerator, {
              business: tab.tableProp.business
            }, null, 8, ["business"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])])])]),
        _: 1
      });
    };
  }
});